<template>
  <div id="app">
    <head-warp></head-warp>
    <router-view />
    <foot-warp></foot-warp>
    <side-warp></side-warp>
  </div>
</template>

<script>
import headWarp from "@/components/common/head";
import footWarp from "@/components/common/footer";
import sideWarp from "@/components/common/side";
export default {
  name: "App",
  data() {
    return {
      metaInfoAttr: {
        description:
          "万杰智能科技股份有限公司（www.wanjiejixie.com）创建于1996年3月，一直致力于和面系列、揉面系列、馒头系列、包馅系列、鲜食面条系列、蒸制系列、大型食品加工生产线系列等民族文化主食机械的研发、制造、营销和服务。 ",
        keywords: "馒头机,馒头生产线,包子机,和面机,揉面机",
        title: "馒头机|馒头生产线|包子机-万杰智能科技股份有限公司  "
      }
    };
  },
  metaInfo() {
    return {
      title: this.metaInfoAttr.title,
      meta: [
        {
          name: "keywords",
          content: this.metaInfoAttr.keywords
        },
        {
          name: "description",
          content: this.metaInfoAttr.description
        }
      ]
    };
  },
  components: {
    headWarp,
    footWarp,
    sideWarp
  },
  watch: {
    $route: "getRoute"
  },
  beforeMount() {
    this.route = location.hash.slice(1);
  },
  mounted() {
    this.getRoute();
    setTimeout(() => {
      this.$router.push(this.route);
    }, 500);
  },
  methods: {
    getRoute() {
      var names = this.$route.meta.seoname;
      this.$post("/api/getseo", {
        name: names
      }).then(res => {
        // console.log(res);
        if (res.data) {
          this.metaInfoAttr = res.data;
        } else {
          this.metaInfoAttr = {
            description:
              "万杰智能科技股份有限公司（www.wanjiejixie.com）创建于1996年3月，一直致力于和面系列、揉面系列、馒头系列、包馅系列、鲜食面条系列、蒸制系列、大型食品加工生产线系列等民族文化主食机械的研发、制造、营销和服务。 ",
            keywords: "馒头机,馒头生产线,包子机,和面机,揉面机",
            title: "馒头机|馒头生产线|包子机-万杰智能科技股份有限公司  "
          };
        }
      });
    }
  }
};
</script>

<style>
@import url("./assets/css/reset.css");
</style>



// WEBPACK FOOTER //
// src/App.vue